import { map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { select, Store } from '@ngrx/store'

import { TranslateService } from '@ngx-translate/core'

import { Observable, Subject } from 'rxjs'

import * as account from '../../actions/account'
import * as fromAuth from '../../reducers'
import * as status from '../../../base/actions/status.actions';

import { ResetRequest } from '../../models/account'

import { ContainerBase } from '../../../core/base/container-base'
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-reset-password-container',
  templateUrl: './template.html'
})
export class ResetPasswordContainer extends ContainerBase implements OnInit, OnDestroy {
  submitting$: Observable<boolean>
  error$: Observable<any>
  isResetLinkValidationCompleted$: Observable<boolean>
  isResetLinkValid$: Observable<boolean>
  token: string

  constructor(
    private store: Store<fromAuth.State>,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) {
    super()

    this.submitting$ = store.pipe(select(fromAuth.isResetting), takeUntil(this.destroyed$))
    this.error$ = store.pipe(select(fromAuth.getResetError), takeUntil(this.destroyed$))
    this.isResetLinkValidationCompleted$ = this.store.pipe(select(fromAuth.isResetTokenValidationCompleted), takeUntil(this.destroyed$))
    this.isResetLinkValid$ = this.store.pipe(select(fromAuth.isResetTokenValid), takeUntil(this.destroyed$))
    this.store.pipe(select(fromAuth.getPageLanguage), takeUntil(this.destroyed$))
      .subscribe(language => {
        if (language) {
          if (language) {
            this.translate.use(language)
          } else {
            this.translate.use(translate.getBrowserLang())
          }
        }
      })

    // remove header space
    //this.store.dispatch(new status.SetHeader(false));

    // this.submit$.pipe(
    //   withLatestFrom(
    //     route.params.pipe(map(param => param['token'])),
    //     (password, token) => (<ResetRequest>{
    //       password,
    //       token
    //     })
    //   ),
    //   map(request => new account.Reset(request)))
    //   .subscribe(store)
  }

  ngOnInit() {
    this.store.dispatch(new account.ResetClear())

    this.route.params.pipe(map(param => param['token']), takeUntil(this.destroyed$))
      .subscribe(token => {
        this.token = token
        this.store.dispatch(new account.ValidateResetLink(token))

        const userId = token.split(':')[0]
        if (userId) {
          this.store.dispatch(new account.UserGetLanguage(token.split(':')[0]))
        }
      })
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  doSubmit(event: {password: string}) {
    this.store.dispatch(new account.Reset(<ResetRequest>{ password: event.password, token: this.token }))
  }
}
